import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';
import {BigWinModule} from '@fantasmagames/slot/src/modules/bigwin/BigWinModule';
import {BigWinView} from '@fantasmagames/slot/src/modules/bigwin/BigWinView';

export class BigWinPlayingState extends ModuleState<BigWinView, BigWinModule> {
	public static LEVEL4_TRESHOLD: number = 100;
	public static LEVEL3_TRESHOLD: number = 70;
	public static LEVEL2_TRESHOLD: number = 40;

	public static BEFORE_BIG_WIN_PAUSE: number = 800;

	public onEnterState(): void {
		this.emit(BigWinEvents.ON_BEFORE_BIG_WIN);

		this.module.timeUtils.createTimer(() => {
			const win: number = this.module.logic.getSpinResult().spinWin;
			this.view.start(win, this.getBigWinLevelFromWinNumber(win));

			this.emit(BigWinEvents.STARTED);
			this.emit(BigWinEvents.COUNTUP_STARTED);
		}, BigWinPlayingState.BEFORE_BIG_WIN_PAUSE);
	}

	public onLeaveState(): void {}

	protected setupEvents(): void {
		this.on(BigWinView.SKIP_CLICKED, this.onSkipClicked);
		this.on(BigWinView.METER_FINISHED, this.onMeterFinished);
	}

	protected getBigWinLevelFromWinNumber(win: number): number {
		if (win >= this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL4_TRESHOLD) {
			return 4;
		}
		if (win >= this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL3_TRESHOLD && win < this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL4_TRESHOLD) {
			return 3;
		}
		if (win >= this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL2_TRESHOLD && win < this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL3_TRESHOLD) {
			return 2;
		}

		return 1;
	}

	protected onSkipClicked(): void {
		this.view.skipCounting();
	}

	protected onMeterFinished(): void {
		this.module.gotoState(BigWinModule.FINAL_STATE);
	}

	protected getBigWinLevel(): number {
		if (WinUtils.inBigWinEpicWin(this.module.logic)) {
			return 4;
		}
		if (WinUtils.inBigWinMegaWin(this.module.logic)) {
			return 3;
		}
		if (WinUtils.inBigWinSuperWin(this.module.logic)) {
			return 2;
		}

		return 1;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/bigwin/states/BigWinPlayingState.ts